import Breadcrumb from "../../Component/Breadcrumb";

function AcademicReg() {
  return (
    <>
      <Breadcrumb>Students / Academic Year & Registration</Breadcrumb>
      <div className="innersec">
        <div className="container">
          <div className="col-lg-12">
            <h1>Admission Guidelines</h1>
          </div>
          <div className="admission-section ">
            {/* === GENERAL ADMISSION RULES === */}
            <div className="admission-card mb-5">
              <h3 className="admission-heading">- General Admission Rules</h3>
              <ol className="admission-list">
                <li>The academic year of the school is from April to March.</li>
                <li>
                  Admission to Playway, Lower K.G., and Upper K.G. classes are
                  taken during February – March.
                </li>
                <li>
                  Application to other classes will be entertained only when
                  vacancies exist.
                </li>
                <li>
                  The prospectus and application form will be available at the
                  school office during the prescribed dates and hours.
                </li>
                <li>
                  Interaction with the child and written test for admission
                  shall be conducted on the informed date.
                </li>
                <li>Date of Birth shall not be changed at any stage later.</li>
                <li>
                  A medical fitness certificate is mandatory (proforma provided
                  by the school).
                </li>
                <li>
                  Registration forms will be issued in the child’s name and are
                  non-transferable.
                </li>
                <li>Registration fee is non-refundable.</li>
              </ol>

              <div className="admission-note">
                <strong>Note:</strong> Registration does not guarantee
                admission. It is subject to merit and availability of seats.
              </div>
            </div>

            {/* === PLAYWAY === */}
            <div className="admission-card mb-5">
              <h3 className="admission-heading">– Playway</h3>
              <ol className="admission-list">
                <li>
                  The child must have completed <strong>3 years</strong> as of
                  March 31st of the admission year.
                </li>
                <li>
                  Stamp-size photographs of the child, father, and mother must
                  be affixed on the application form.
                </li>
                <li>
                  A valid <strong>Birth Certificate</strong> from
                  Panchayat/Nagarpalika or competent authority must be
                  submitted.
                </li>
              </ol>
            </div>

            {/* === LKG & UKG === */}
            <div className="admission-card mb-5">
              <h3 className="admission-heading">– LKG & UKG</h3>
              <ol className="admission-list">
                <li>
                  Admission involves an interview and written tests in English,
                  Mathematics, and Hindi. A minimum of <strong>50%</strong>{" "}
                  marks is required in each subject.
                </li>
                <li>
                  The child must have completed <strong>4 years (LKG)</strong>{" "}
                  or <strong>5 years (UKG)</strong> by March 31st of the
                  admission year.
                </li>
                <li>
                  Stamp-size photographs of the child, father, and mother must
                  be affixed on the application form.
                </li>
                <li>
                  Submission of <strong>Birth Certificate/TC</strong>, mark
                  sheet, and <strong>PEN number</strong> from the last school
                  attended is required.
                </li>
              </ol>
            </div>

            {/* === CLASS I TO IX === */}
            <div className="admission-card mb-5">
              <h3 className="admission-heading">– Class I to IX</h3>
              <ol className="admission-list">
                <li>
                  Admission to these classes will be considered only when
                  vacancies exist.
                </li>
                <li>
                  Written tests will be held in{" "}
                  <strong>
                    English, Mathematics, Hindi, Science, and Social Science.
                  </strong>{" "}
                  Students must score at least <strong>70%</strong> in each
                  subject to qualify.
                </li>
                <li>
                  Transfer Certificate, Mark Sheet, and{" "}
                  <strong>PEN number</strong> from the last attended school must
                  be submitted.
                </li>
              </ol>
            </div>

            {/* === CLASS XI === */}
            <div className="admission-card mb-5">
              <h3 className="admission-heading">– Class XI</h3>
              <p className="intro-text">
                The school offers <strong>three streams</strong> for Higher
                Secondary students:
              </p>
              <ul className="stream-list">
                <li>
                  <strong>Science (Mathematics)</strong> — Hindi Core/Computer
                  Science, English Core, Mathematics, Physics, Chemistry
                </li>
                <li>
                  <strong>Science (Biology)</strong> — Hindi Core/Computer
                  Science, English Core, Biology, Physics, Chemistry
                </li>
                <li>
                  <strong>Commerce</strong> — Hindi Core/Computer Science,
                  English Core, Accountancy, Business Studies, Economics
                </li>
              </ul>

              <div className="admission-note">
                <strong>Note:</strong> Group allocation is based on the marks
                obtained by the student in pre-board exams conducted by the
                school.
              </div>

              <p className="admission-footer">
                Admission of students from outside the institution will be
                considered only in case of available vacancies, after
                accommodating students from this school. External students must
                have scored at least <strong>75%</strong> marks in the relevant
                subjects.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default AcademicReg;
